export default __webpack_public_path__ + "static/media/search.3b671ba1.svg";